import {
  GPX_CAPABILITIES,
  GPX_EVENT_TYPES,
  GPX_FEATURES,
  GPX_ROUTES,
  gspx,
} from '@rsos/gainsight';
import type { KeywordSet } from '@rsos/reduxDataStore';

export { GPX_EVENT_TYPES } from '@rsos/gainsight';

export const KEYWORD_MATCH_EVENTS = Object.freeze({
  KEYWORD_CLICKED: 'keyword_clicked',
  KEYWORD_HOVERED: 'keyword_hovered',
});

export const trackKeywordMatchEvent = ({
  event,
  type,
  data,
}: {
  event: string;
  type: (typeof GPX_EVENT_TYPES)[keyof typeof GPX_EVENT_TYPES];
  data: Record<string, unknown>;
}) => {
  gspx.trackEvent({
    name: event,
    type: type,
    feature: GPX_FEATURES.KEYWORD_DETECTION,
    capability: GPX_CAPABILITIES.COMMUNICATOR_SUMMARIZATION_AND_KEYWORDS,
    route: GPX_ROUTES.COMMUNICATOR,
    entities: data,
  });
};

export const trackKeywordClicked = (keywordSet: KeywordSet) => {
  trackKeywordMatchEvent({
    event: KEYWORD_MATCH_EVENTS.KEYWORD_CLICKED,
    type: GPX_EVENT_TYPES.CLICK,
    data: {
      keyword_set_id: keywordSet.id,
      keyword_set_name: keywordSet.name,
      keyword_set: keywordSet,
    },
  });
};

export const trackKeywordHovered = (
  keywordSet: KeywordSet,
  words: string[],
) => {
  trackKeywordMatchEvent({
    event: KEYWORD_MATCH_EVENTS.KEYWORD_HOVERED,
    type: GPX_EVENT_TYPES.INFO,
    data: {
      keyword_set_id: keywordSet.id,
      keyword_set_name: keywordSet.name,
      words,
      keyword_set: keywordSet,
    },
  });
};
